import type { FormEvent } from "react";
import { isPhoneInputValid, isCodeInputValid } from "./dashboardModel";
export type LoginState = "idle" | "sending" | "loggingIn";

export function TeacherLoginCard({
  code,
  cooldown,
  error,
  loginState,
  onCodeChange,
  onLogin,
  onPhoneChange,
  onSendCode,
  phone,
}: {
  code: string;
  cooldown: number;
  error: string;
  loginState: LoginState;
  onCodeChange: (value: string) => void;
  onLogin: (event: FormEvent<HTMLFormElement>) => void;
  onPhoneChange: (value: string) => void;
  onSendCode: () => void;
  phone: string;
}) {
  const canSendCode = isPhoneInputValid(phone) && loginState === "idle" && cooldown <= 0;
  const canSubmitLogin = isPhoneInputValid(phone) && isCodeInputValid(code) && loginState === "idle";

  return (
    <section className="student-login-page teacher-login-page">
      <article className="student-login-card teacher-login-card">
        <div className="student-login-header">
          <div className="student-login-brand" aria-label="迹时运动">
            <img src="/pingpi-logo.png?v=cff2de3ac9d0" alt="" aria-hidden="true" />
            <span>迹时运动</span>
          </div>
          <span className="student-login-mark">教师看板</span>
        </div>

        <div className="student-login-copy teacher-login-copy">
          <h2>老师登录</h2>
          <p>登录后查看班级使用、学生记录和 AI教练结果。</p>
        </div>

        <form className="student-login-form teacher-login-form" onSubmit={onLogin}>
          <label className="student-login-field">
            <span className="student-login-prefix">+86</span>
            <input
              aria-label="手机号"
              autoComplete="username"
              inputMode="numeric"
              maxLength={11}
              name="phone"
              onChange={(event) => onPhoneChange(event.target.value.replace(/\D/g, "").slice(0, 11))}
              placeholder="11 位手机号"
              type="tel"
              value={phone}
            />
          </label>
          <label className="student-login-field">
            <input
              aria-label="验证码"
              autoComplete="one-time-code"
              inputMode="numeric"
              maxLength={6}
              name="code"
              onChange={(event) => onCodeChange(event.target.value.replace(/\D/g, "").slice(0, 6))}
              placeholder="6 位验证码"
              type="text"
              value={code}
            />
            <button className="student-login-code" disabled={!canSendCode} type="button" onClick={onSendCode}>
              {cooldown > 0 ? `已发送(${cooldown}s)` : loginState === "sending" ? "发送中" : "获取验证码"}
            </button>
          </label>
          {error ? <p className="form-error">{error}</p> : null}
          <button className="primary-button student-login-submit" disabled={!canSubmitLogin} type="submit">
            {loginState === "loggingIn" ? "登录中" : "进入看板"}
          </button>
        </form>
      </article>
    </section>
  );
}
